import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=0a4fa99a"
import script from "./AdminSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettings.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports